import script from "./FamilyGroupInviteRecipient.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupInviteRecipient.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupInviteRecipient.vue?vue&type=style&index=0&id=5d448ab9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d448ab9"]])

export default __exports__